import React, { useMemo } from 'react';
import AssistantChat from './AssistantChat';
import { earningsCallChatConfig } from './assistantChatConfigs';

function EarningsCallChat(props: { ticker?: string; transcript: any }) {
  const config = useMemo(
    () => earningsCallChatConfig(props),
    [props.ticker, props.transcript]
  );
  return <AssistantChat config={config} />;
}

export default EarningsCallChat;
